import PropTypes from 'prop-types'
import React from 'react'

import * as styles from './ReviewSection.module.scss'
import { colors } from '../../../constants/style'
import { SvgAppStore, SvgQuoteNew } from '../../ui/svg-icons'

function ReviewSection({
  title,
  text,
  authorName,
  iconColor = colors.blue50,
  backgroundColor,
  appStore,
}) {
  return (
    <section className={styles.section} style={{ backgroundColor }}>
      <div className={styles.container}>
        <div className={styles.contentWrap}>
          <SvgQuoteNew fill={iconColor} className={styles.icon} />
          {title && <h2 className="visually-hidden">{title}</h2>}

          {text && <p className={styles.text}>{text}</p>}
          {authorName && <p className={styles.authorName}>{authorName}</p>}

          {appStore && <SvgAppStore />}
        </div>
      </div>
    </section>
  )
}

ReviewSection.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  authorName: PropTypes.string,
}

export default ReviewSection
